import React, { useState } from "react";

import { faExpand } from "@fortawesome/pro-regular-svg-icons";
import { createPortal } from "react-dom";

import { GenericObject } from "src/api/flowTypes";
import { CopyTextIcon } from "src/base-components/CopyTextIcon";
import { Icon } from "src/base-components/Icon";
import { FloatingWindowInternal } from "src/datasets/DatasetTable/FloatingWindow";
import { ObjectDetailPane } from "src/dataTable/ObjectDetailPane";
import { copyTextToClipboard } from "src/utils/clipboard";

type Props = {
  dataLoc?: string;
  value: GenericObject;
  field: string;
};

export const JSONValueViewer: React.FC<Props> = ({ dataLoc, value, field }) => {
  const [showExpanded, setShowExpanded] = useState(false);
  return (
    <div className="relative w-full">
      <div className="absolute top-2 right-5 z-10 flex items-center justify-end gap-x-1">
        <CopyTextIcon
          feedback="inline"
          size="2xs"
          value={() => JSON.stringify(value)}
        />
        <Icon
          color="text-gray-500 hover:text-gray-800"
          icon={faExpand}
          size="2xs"
          onClick={() => setShowExpanded(!showExpanded)}
        />
        {showExpanded &&
          createPortal(
            <FloatingWindowInternal
              draggable={false}
              isMaximized={true}
              isPinned={false}
              maximizable={false}
              style={undefined}
              title={field}
              onClose={() => setShowExpanded(false)}
              onCopy={() => copyTextToClipboard(JSON.stringify(value))}
            >
              <ObjectDetailPane
                dataLoc={dataLoc}
                defaultInspectDepth={3}
                enableClipboard={false}
                innerDimensionClass="h-full"
                jsonObject={value}
              />
            </FloatingWindowInternal>,
            document.body,
          )}
      </div>
      <ObjectDetailPane
        dataLoc={dataLoc}
        defaultInspectDepth={3}
        enableClipboard={false}
        innerDimensionClass="max-h-44"
        jsonObject={value}
      />
    </div>
  );
};
